var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicMuted = function SvgMicMuted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0274 2C9.98387 2 8.32129 3.66258 8.32129 5.70609V10.4281C8.32129 12.4713 9.98387 14.1339 12.0274 14.1339C14.0709 14.1339 15.7335 12.4829 15.7335 10.4535V5.70609C15.7335 3.66258 14.0709 2 12.0274 2ZM13.5279 10.4533C13.5279 11.2556 12.6885 11.9284 12.0274 11.9284C11.3663 11.9284 10.5266 11.2969 10.5266 10.4278V5.70609C10.5266 4.89238 11.139 4.20532 12.0274 4.20532C12.9158 4.20532 13.5279 4.91304 13.5279 5.70609V10.4533Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1018 16.3381H10.9531V19.809H13.1018V16.3381Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2137 18.7346H9.84141C9.38287 18.7346 9.01123 19.1508 9.01123 19.6643C9.01123 20.1778 9.38287 20.594 9.84141 20.594H14.2137C14.6723 20.594 15.0439 20.1778 15.0439 19.6643C15.0439 19.1508 14.6723 18.7346 14.2137 18.7346Z",
    fill: "#202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9525 10.3806C17.3785 10.3806 16.8499 10.8915 16.8499 11.318C16.8499 13.5283 14.7198 15.2704 12.0276 15.2704C9.59922 15.2704 7.20532 13.7142 7.20532 11.318C7.20532 10.8915 6.76824 10.3806 6.10266 10.3806C5.43708 10.3806 5 10.8915 5 11.318C5 14.7265 8.28815 17.3931 12.0276 17.3931C15.767 17.3931 19.0552 14.8092 19.0552 11.318C19.0552 10.8916 18.5974 10.3806 17.9525 10.3806Z",
    fill: "#202020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6777 2.70725C21.0682 3.09777 21.0682 3.73094 20.6777 4.12146L5.12132 19.6778C4.7308 20.0683 4.09763 20.0683 3.70711 19.6778V19.6778C3.31658 19.2873 3.31658 18.6541 3.70711 18.2636L19.2635 2.70725C19.654 2.31672 20.2871 2.31672 20.6777 2.70725V2.70725Z",
    fill: "#EE0606"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicMuted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic-muted.8b3da054.svg";
export { ForwardRef as ReactComponent };